/**
 * Carrier pricing-quote result + its enums, extracted from
 * `redo/model/src/outbound-labels/pricing-calculator.ts` (whose file is
 * heavily model-entangled) so the OutboundLabelSettings slice can reference
 * `CarrierQuoteResult` without a model↔leaf cycle. The origin file stays in
 * redo/model and re-imports these.
 */
import { RateTableCarrier } from "./rate-table-carrier";

export enum PricingStrategy {
  Spread = "spread",
  Discount = "discount",
}

export enum SpreadUnit {
  Dollars = "dollars",
  Percent = "percent",
}

export interface CarrierQuoteResult {
  carrier: RateTableCarrier;
  strategy: PricingStrategy;
  amount: number;
  unit?: SpreadUnit;
  ordersWon: number;
  ordersWonPct: number;
  totalMerchantSavings: number;
  totalRedoProfit: number;
  avgMerchantSavingsPerOrder: number;
  avgRedoProfitPerOrder: number;
  monthlySavings: number;
  annualSavings: number;
  annualRedoProfit: number;
}
